$(document).ready(function() {
    var ourPartner = new Swiper(".js-partner-swiper", {
        slidesPerView: 5,
        autoPlay: true,
        // centeredSlides: true,
        // effect: 'slide',
        // centeredSlides: true
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            // when window width is >= 640px
            640: {
                slidesPerView: 3,
                spaceBetween: 40
            },
            992: {
                slidesPerView: 4,
                spaceBetween: 40
            }
        }
    });


})